import { CalendarHeart, Sun, UsersRound } from "lucide-react";
import { IMAGES, STEPS } from "../../lib/content";
import { Reveal } from "./Reveal";

const ART = [
  { Icon: UsersRound, blob: "#F8EFEA", ink: "#C85A32", path: "M44 6c17 2 31 15 30 33s-15 35-35 35S2 60 4 40 27 4 44 6z" },
  { Icon: CalendarHeart, blob: "#EAF0EC", ink: "#536B5B", path: "M38 4c20 0 36 14 36 34S58 76 36 74 2 58 4 36 18 4 38 4z" },
  { Icon: Sun, blob: "#FAF3E8", ink: "#B9823F", path: "M40 3c18 3 34 18 33 37S56 75 37 75 3 62 4 40 22 0 40 3z" },
];

const StepArt = ({ i }) => {
  const { Icon, blob, ink, path } = ART[i];
  return (
    <div className="relative h-20 w-20">
      <svg viewBox="0 0 78 78" className="absolute inset-0 h-full w-full" aria-hidden="true">
        <path d={path} fill={blob} />
        <path d="M10 60 C 25 50, 50 70, 68 54" stroke={ink} strokeWidth="1.5" fill="none" strokeDasharray="3 4" opacity="0.6" />
      </svg>
      <Icon className="absolute inset-0 m-auto h-8 w-8" style={{ color: ink }} strokeWidth={1.6} />
    </div>
  );
};

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="section bg-[#FDFBF7] pt-0">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
      <Reveal>
        <p className="eyebrow">How it works</p>
        <h2 data-testid="how-it-works-heading" className="section-title mt-4 max-w-2xl">Simple. Warm. Built for real families.</h2>
      </Reveal>

      <ol className="mt-16 grid gap-6 md:grid-cols-3">
        {STEPS.map((text, i) => {
          const [lead, rest] = text.split(" — ");
          return (
            <Reveal as="li" key={text} delay={i * 140}>
              <div data-testid={`how-it-works-step-${i + 1}`} className="warm-card relative h-full p-8 sm:p-10">
                <span className="absolute right-8 top-7 font-serif text-5xl font-light text-[#E6DEC6]">0{i + 1}</span>
                <StepArt i={i} />
                <p className="mt-8 text-base sm:text-lg leading-relaxed text-[#5C4F4A]">
                  <span className="font-serif text-xl sm:text-2xl text-[#2C221E] block mb-2">{lead} —</span>
                  {rest}
                </p>
              </div>
            </Reveal>
          );
        })}
      </ol>

      <Reveal delay={150} className="mt-16">
        <div className="photo-frame aspect-[16/10] sm:aspect-[21/9]">
          <img src={IMAGES.bikeRide.src} alt={IMAGES.bikeRide.alt} loading="lazy" className="h-full w-full object-cover object-[center_60%]" />
        </div>
      </Reveal>
    </div>
  </section>
);
